import $ from "dabbyjs/src/core/dabby/dabby.js";
import submit from "./submit.js";
import file from "./file.js";
import { setup, filebrowser } from "./html.js";
import selectsearch from "./selectsearch.js";
import selectall from "./selectall.js";
import notify from "./notify.js";
import recaptcha from "./recaptcha.js";
import progress from "./progress.js";
import labels from "./labels.js";
import select from "./select.js";
import textarea from "./textarea.js";
import show from "./show.js";

export default () => {

	// keyboard selectable labels
	labels($("label[for][tabindex]"));

	// change which submit button pressing enter on an input control uses
	submit($("input[data-submit]"), "submit");

	// custom file input control
	file($(".form__upload-control"), ".form__upload-filename");

	// CKEditor
	setup($("textarea[data-editor]"));
	filebrowser($(".form__upload-file, .form__view-url-link"), "form__link-insert");

	// ajax search drop-down control
	selectsearch($(".form__control-selectsearch"), ".form__control-selectsearch");

	// select all items in a fieldset when label is clicked
	selectall($(".form__wrapper fieldset[id]"));

	// filter one select with another
	select($("select[data-filter]"));

	// notify when you have changed form then navigated away without saving
	notify($("form[method=post]:not([data-notify-ignore])"));

	// process recaptcha challenges, must be before progress
	recaptcha($("input[data-recaptcha]"));

	// notify when you have changed form then navigated away without saving
	progress($("form[data-progress], form[enctype='multipart/form-data']"));

	// limit characters than can be input in a textarea
	textarea($("textarea[maxlength]"));

	// show and hide form controls
	show($(".form__wrapper[data-show]"));
};
